import { useState } from "react";
import SearchDocContext from "./searchDocContext";
import { searchDocFromAPI } from "../../api/api";

const SearchDocState = (props) => {
  const [foundedSearchDoc, setSearchDocID] = useState("");
  const [showError, setError] = useState("");
  const [startLoading, setLoading] = useState(false); // Loading state


  // Function to search document
  const seachDocumentFun = async (document) => {
    if (!document) {
      setSearchDocID("");
      setError("Please enter your document ID");
    } else {
      setError("");
      setLoading(true); // Start loading
      try {
        const searchDocBody = { certification_search_id: document };
        const searchDocResponse = await searchDocFromAPI(searchDocBody);
        setSearchDocID(searchDocResponse);
      } catch (error) {
        setError("Failed to fetch document.");
      } finally {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
        // setLoading(false); // Stop loading after API call completes
      }
    }
  };

  // Function to handle document download
  const handleDownload = () => {
    if (foundedSearchDoc && foundedSearchDoc.certification?.certification_url) {
      const downloadUrl = foundedSearchDoc.certification.certification_url;
      window.open(downloadUrl, "_blank");

      // // Extract filename from URL
      // const fileName = downloadUrl.split("/").pop();
  
      // if (!fileName) {
      //   setError("Filename could not be determined.");
      //   return;
      // }
  
      // Open in a new tab
  
      // // Trigger download
      // const link = document.createElement("a");
      // link.href = downloadUrl;
      // link.download = fileName;
      // document.body.appendChild(link);
      // link.click();
      // document.body.removeChild(link);
    } else {
      setError("Download link not available.");
    }
  };
  
  

  return (
    <SearchDocContext.Provider
      value={{ foundedSearchDoc, showError, startLoading, seachDocumentFun, handleDownload }}
    >
      {props.children}
    </SearchDocContext.Provider>
  );
};

export default SearchDocState;
